import { Component, inject } from '@angular/core';
import { clsx } from 'clsx';

import { RadioBaseDirective } from '../radio-base/radio-base.directive';

@Component({
  selector: 'sb-radio-badge',
  templateUrl: './radio-badge.component.html',
  hostDirectives: [{ directive: RadioBaseDirective, inputs: ['value', 'checked', 'disabled', 'name', 'id'] }],
  host: {
    class: 'relative',
  },
})
export class RadioBadgeComponent {
  base = inject(RadioBaseDirective);

  labelClasses = clsx(
    'm-0 inline-flex cursor-pointer items-center justify-center whitespace-nowrap select-none',
    'rounded border border-solid border-default bg-surface-page px-3 py-2',
    // No `outline-hidden`: it sets `--tw-outline-style: none`, which the
    // `peer-focus-visible:outline` ring below reads — hiding the focus ring.
    'text-center text-base font-medium text-default outline-offset-2',
    'hover:border-brand hover:text-brand',
    'peer-checked:border-brand-subtle peer-checked:bg-brand-subtle peer-checked:text-brand',
    'peer-focus-visible:border-brand-subtle peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-brand',
    'peer-disabled:pointer-events-none peer-disabled:text-disabled peer-disabled:opacity-30',
  );
}
